window.initMap = () => {
    if (typeof window.google === 'undefined') {
        return;
    }

    let containers = [
        {street: 'Kahlspergstraße', city: 'Oberalm', lat: 47.701166, lng: 13.090877},
        {street: 'Bahnhof Oberalm', city: 'Oberalm', lat: 47.700136, lng: 13.094360},
        {street: 'Halleiner Landesstraße', city: 'Oberalm', lat: 47.705597, lng: 13.094376},
        {street: 'Halleiner Landesstraße', city: 'Oberalm', lat: 47.690388, lng: 13.100138},
        {street: 'Drei Linden Siedlung', city: 'Puch', lat: 47.725450, lng: 13.089902},
        {street: 'Jägerwirtstraße ', city: 'Puch', lat: 47.708675, lng: 13.091884},
        {street: 'Neualmerstraße 33', city: 'Hallein', lat: 47.690077, lng: 13.085999},
        {street: 'Solvay-Halvic-Straße', city: 'Hallein', lat: 47.695319, lng: 13.083375},
        {street: 'Dürrnberg Landesstraße', city: 'Hallein', lat: 47.680867, lng: 13.089220},
        {street: 'Brückenwirtweg', city: 'Hallein', lat: 47.723230, lng: 13.061797},
        {street: 'Mooslehenweg', city: 'Hallein', lat: 47.701321, lng: 13.073908},
        {street: 'Bürgermeisterstraße', city: 'Hallein', lat: 47.685737, lng: 13.114911},
        {street: 'Davisstraße', city: 'Hallein', lat: 47.675278, lng: 13.103262},
        {street: 'Am Weinberg', city: 'Hallein', lat: 47.694193, lng: 13.111913},
        {street: 'Neualmerstraße,Alm', city: 'Hallein', lat: 47.686212, lng: 13.095377},
        {street: 'Maraltstraße', city: '', lat: 47.686586, lng: 13.109055},
        {street: 'Salzachtalstraße', city: '', lat: 47.677191, lng: 13.107204},
        {street: 'Viertalerstraße 1', city: 'Hallein', lat: 47.693923, lng: 13.089913},
        {street: 'Sikorastraße 10', city: 'Hallein', lat: 47.693615, lng: 13.092330},
        {street: 'Raxlanerhofstraße 10', city: 'Hallein', lat: 47.680697, lng: 13.111321},
        {street: 'Faberhofstraße 6', city: 'Hallein', lat: 47.679737, lng: 13.113051},
        {street: 'Fallnhauserhofstraße 4', city: 'Hallein', lat: 47.678619, lng: 13.114389},
        {street: 'Austrocell', city: 'Hallein', lat: 47.674954, lng: 13.111894},
        {street: 'Strubau', city: 'Kuchl', lat: 47.616182, lng: 13.174740},
        {street: 'Jadorf', city: 'Kuchl', lat: 47.639392, lng: 13.138035},
        {street: 'Garnei', city: 'Kuchl', lat: 47.652542, lng: 13.128559},
        {street: 'Markt 357-359', city: 'Kuchl', lat: 47.629230, lng: 13.145582},
        {street: 'UNI-Markt', city: 'Kuchl', lat: 47.608579, lng: 13.167346},
        {street: 'WSP Container I & II', city: 'Golling', lat: 47.602311, lng: 13.163845},
        {street: 'Bahn, Lärmschutzwand', city: 'Golling', lat: 47.601895, lng: 13.163845},
        {street: 'BILLA Oberalm', city: 'Oberalm', lat: 47.703530, lng: 13.096192},
        {street: 'BILLA Kuchl', city: 'Kuchl', lat: 47.632121, lng: 13.139565},
        {street: 'BILLA Elsbethen', city: 'Elsbethen', lat: 47.748072, lng: 13.085328},
        {street: 'WSP Container I, II, III', city: 'Grödig', lat: 47.741858, lng: 13.030302},
        {street: 'Neue Mittelschule I & II', city: 'Grödig', lat: 47.739224, lng: 13.044895},
         // new from 2021-03-24:
         {street: 'Schulstraße', city: 'Puch', lat: 47.710700, lng: 13.084956},
         {street: 'Funbike/Bergspezl', city: 'Puch', lat: 47.711847, lng: 13.092404},
         {street: 'Bürgermeisterstraße', city: 'Hallein', lat: 47.685737, lng: 13.114911},
         {street: 'Rudolf-Winklerstr. 2 b', city: 'Hallein', lat: 47.680831, lng: 13.101319},
         {street: 'Salzberghalle', city: 'Hallein', lat: 47.678644, lng: 13.094853},
         {street: 'Maraltstraße II', city: 'Hallein', lat: 47.686586, lng: 13.109055},
         {street: 'Fürstenbrunn', city: 'Grödig', lat: 47.747242, lng: 12.992503},
         {street: 'St. Leonhard', city: 'Grödig', lat: 47.727591, lng: 13.041528},
    ];
    
    function makeMap(element) {
        if (element.dataset.initialized) {
            return;
        }
        element.dataset.initialized = 'true';
        let bounds = new google.maps.LatLngBounds();
        let infoWindow = new google.maps.InfoWindow();
        let map = new google.maps.Map(element);
        function makeMarker(container) {
            let marker = new google.maps.Marker({
                position: {lat: container.lat, lng: container.lng},
                map: map
            });
            bounds.extend(marker.position);
            marker.addListener('mouseover', function() {
                infoWindow.setContent('<p class="info-window">' + container.street + '<br>' + container.city + '</p>');
                infoWindow.open(map, marker);
            });
            marker.addListener('mouseout', function() {
                infoWindow.close();
            });
        }

        for (let idx = 0; idx < containers.length; idx++) {
            makeMarker(containers[idx]);
        }

        map.fitBounds(bounds);
    }

    let elements = document.getElementsByClassName('container-map__map');
    for (let idx = 0; idx < elements.length; idx++) {
        makeMap(elements[idx]);
    }
}

window.initMap();
if (typeof document.addEventListener === 'function') {
    document.addEventListener('Neos.PageLoaded', function() { window.initMap(); }, false);
    document.addEventListener('Neos.NodeCreated', function() { window.initMap(); }, false);
}
